var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagepillcloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06501 0.242589L4.48528 3.82232L0.905553 0.242589C0.72249 0.0595256 0.425704 0.0595256 0.242641 0.242589C0.0595773 0.425652 0.0595773 0.722438 0.242641 0.905501L3.82237 4.48523L0.242641 8.06496C0.0595773 8.24802 0.0595773 8.54481 0.242641 8.72787C0.425704 8.91093 0.72249 8.91093 0.905553 8.72787L4.48528 5.14814L8.06501 8.72787C8.24807 8.91093 8.54486 8.91093 8.72792 8.72787C8.91099 8.54481 8.91098 8.24802 8.72792 8.06496L5.14819 4.48523L8.72792 0.905501C8.91098 0.722438 8.91099 0.425652 8.72792 0.242589C8.54486 0.0595256 8.24807 0.0595259 8.06501 0.242589Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagepillcloseIcon);
export default __webpack_public_path__ + "static/media/imagepillcloseIcon.b6a528961b62eb53c6900f4bf5677cd4.svg";
export { ForwardRef as ReactComponent };